import { render, staticRenderFns } from "./RoundConfigFormCheckList.vue?vue&type=template&id=5bf03472"
import script from "./RoundConfigFormCheckList.vue?vue&type=script&lang=js"
export * from "./RoundConfigFormCheckList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports